var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRollingStockVehicles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 51C39.8071 51 51 39.8071 51 26C51 12.1929 39.8071 1 26 1C12.1929 1 1 12.1929 1 26C1 39.8071 12.1929 51 26 51Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 51C39.8071 51 51 39.8071 51 26C51 12.1929 39.8071 1 26 1C12.1929 1 1 12.1929 1 26C1 39.8071 12.1929 51 26 51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 39.42C33.4117 39.42 39.4201 33.4117 39.4201 26C39.4201 18.5884 33.4117 12.58 26.0001 12.58C18.5884 12.58 12.5801 18.5884 12.5801 26C12.5801 33.4117 18.5884 39.42 26.0001 39.42Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 39.42C33.4117 39.42 39.4201 33.4117 39.4201 26C39.4201 18.5884 33.4117 12.58 26.0001 12.58C18.5884 12.58 12.5801 18.5884 12.5801 26C12.5801 33.4117 18.5884 39.42 26.0001 39.42Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30.29C28.3693 30.29 30.29 28.3693 30.29 26C30.29 23.6307 28.3693 21.71 26 21.71C23.6307 21.71 21.71 23.6307 21.71 26C21.71 28.3693 23.6307 30.29 26 30.29Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30.29C28.3693 30.29 30.29 28.3693 30.29 26C30.29 23.6307 28.3693 21.71 26 21.71C23.6307 21.71 21.71 23.6307 21.71 26C21.71 28.3693 23.6307 30.29 26 30.29Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19.1C27.1046 19.1 28 18.2045 28 17.1C28 15.9954 27.1046 15.1 26 15.1C24.8954 15.1 24 15.9954 24 17.1C24 18.2045 24.8954 19.1 26 19.1Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 23.55C19.3946 23.55 20.29 22.6546 20.29 21.55C20.29 20.4454 19.3946 19.55 18.29 19.55C17.1855 19.55 16.29 20.4454 16.29 21.55C16.29 22.6546 17.1855 23.55 18.29 23.55Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 32.45C19.3946 32.45 20.29 31.5546 20.29 30.45C20.29 29.3454 19.3946 28.45 18.29 28.45C17.1855 28.45 16.29 29.3454 16.29 30.45C16.29 31.5546 17.1855 32.45 18.29 32.45Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36.9C27.1046 36.9 28 36.0046 28 34.9C28 33.7955 27.1046 32.9 26 32.9C24.8954 32.9 24 33.7955 24 34.9C24 36.0046 24.8954 36.9 26 36.9Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.71 32.45C34.8145 32.45 35.71 31.5546 35.71 30.45C35.71 29.3454 34.8145 28.45 33.71 28.45C32.6054 28.45 31.71 29.3454 31.71 30.45C31.71 31.5546 32.6054 32.45 33.71 32.45Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.71 23.55C34.8145 23.55 35.71 22.6546 35.71 21.55C35.71 20.4454 34.8145 19.55 33.71 19.55C32.6054 19.55 31.71 20.4454 31.71 21.55C31.71 22.6546 32.6054 23.55 33.71 23.55Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingStockVehicles);
export default __webpack_public_path__ + "static/media/RollingStockVehicles.8d81829ddc3b572ef7bc22cdb2c24e8b.svg";
export { ForwardRef as ReactComponent };